import React from "react";
import Slider from "react-slick";
import { ChevronLeft, ChevronRight } from "../../../normalizer";
import Ranking from "./Ranking";
import CustomButton from "../../CustomButton";

function GamificationNextArrow({ onClick, secondaryText, textColor }) {
 return (
    <CustomButton tight small link
      className="ranking-card-arrow"
      onClick={onClick}
    >
      <ChevronRight />
    </CustomButton>
  );
}

function GamificationPrevArrow({ onClick, secondaryText, textColor }) {

  return (
    <CustomButton tight small link
      className="ranking-card-arrow"
      onClick={onClick}
    >
      <ChevronLeft />
    </CustomButton>
  );
}
const RankingCard = ({ rankings, secondaryText, textColor }) => {

  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    nextArrow: <GamificationNextArrow secondaryText={secondaryText} textColor={textColor} />,
    prevArrow: <GamificationPrevArrow secondaryText={secondaryText} textColor={textColor} />,
    dots: true,
    fade: true,
    autoplay: true,
    autoplaySpeed: 7500,
    cssEase: "linear",
    width: '100%',
    className: 'ranking-card-slider',
    // dotsClass: 'ranking-card-dots',
    appendDots: (dots) => (
      <div>
        <ul className="ranking-card-dots"> {dots} </ul>
      </div>
    ),
    customPaging: (i) => <span className="ranking-card-dot"></span>,
  };

  if (rankings.length === 0) {
    return <>Sem Rankings</>;
  }

  return (
    <Slider {...settings}>
      {rankings.map((ranking, i) => {
        return (
            <Ranking
              className="ranking-card-ranking"
              key={i}
              ranking={ranking}
              secondaryText={secondaryText}
              textColor={textColor}
            />
        );
      })}
    </Slider>
  );
};

export default RankingCard;

//
